import { RequestParams, ResponseCatalog } from 'Models'
import { ChannelModel } from 'Pages/referenceBooks'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'

export const oldChannelApi = {
	getAll: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ChannelModel>>(`${urls.channels.index}`, {
			params: requestParams,
		})
		return res.data
	},
}
